import { create } from 'zustand';
import { Theme } from '../generated/gql-types';
import { createJSONStorage, persist } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';
import themeDefault from '../config/theme.default.workerApp.json';
import { themeActions } from './theme.action';

interface ThemeState {
  theme: Theme | null;
  fetchTheme: (tenantId: string, appContext: string) => Promise<Theme | null>;
  setTheme: (theme: any) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      //   state
      theme: null,

      //   setters
      setTheme: (theme) => set({ theme }),

      //   actions
      fetchTheme: async (tenantId: string, appContext: string) => {
        const theme = await themeActions.fetchTheme(tenantId, appContext);
        set({ theme: theme || themeDefault });
        return theme;
      },
    }),
    {
      name: 'theme-storage',
      storage: createJSONStorage(() => AsyncStorage),
      partialize: (state) => ({ theme: state.theme }),
    },
  ),
);
